import styled from "styled-components";

export const PolicyBox = styled.div`
  word-break: break-all;
  overflow-wrap: break-word;
  max-width: 100%;
  & * {
    max-width: 100% !important;
    box-sizing: border-box;
  }
`;